import styled from 'styled-components'

import { media } from 'featureSliced/shared/utils/breakpoints'

type SideBarProps = {
  isSidebarShowing?: boolean
}

export const SidebarContainer = styled('div')<SideBarProps>`
  height: 100vh;
  height: 100dvh;
  width: 300px;
  position: absolute;
  background: ${({ theme }) => theme.MainBackGround};
  top: 0;
  left: ${({ isSidebarShowing }) => (isSidebarShowing ? '0%' : '-100%')};
  transition: left 0.5s;
  position: absolute;
  z-index: 4;

  /* QRM-641: on the web layout the drawer comes in from the right instead */
  ${media.web} {
    position: fixed;
    width: 380px;
    max-width: 90vw;
    left: auto;
    right: ${({ isSidebarShowing }) => (isSidebarShowing ? '0' : '-100%')};
    transition: right 0.35s ease-out;
    z-index: 6;
    overflow-y: auto;
    box-shadow: -12px 0 40px rgba(0, 0, 0, 0.26);
  }
`

export const AGBText = styled.p`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 20px 0;
  color: ${({ theme }) => theme.FontColor};
  & span {
    text-decoration: underline;
  }
`

export const RestaurantInfoBanner = styled.p`
  font-weight: 600;
  font-size: 18px;
  min-height: 58px;
  width: 100%;
  line-height: 30px;
  padding: 14px 0;
  text-align: center;
  color: ${({ theme }) => theme.FontColor};
  border-bottom: 1px solid #c4c4c4;
`

export const SidebarLink = styled.a`
  margin: 0;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  color: ${({ theme }) => theme.colour};
  display: block;
  text-decoration: underline;
  &:visited {
    color: ${({ theme }) => theme.FontColor};
  }
  &:active {
    color: ${({ theme }) => theme.colour};
  }
  &:hover {
    color: ${({ theme }) => theme.colour};
  }
`

// SIDEBAR

export const SidebarItemContainer = styled.div`
  display: grid;
  grid-template-columns: 50px 1fr;
  grid-template-rows: 36px 1fr;
  border-bottom: 1px solid #c4c4c4;
  z-index: 4;
`

export const SidebarItem = styled.p`
  color: #555;
  margin: 0;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  color: ${({ theme }) => theme.FontColor};
`

export const SidebarItemTextContainer = styled.div`
  padding: 15px 0;
  position: relative;
`

export const SidebarTitle = styled.p`
  color: #979797;
  margin: 0;
  margin-left: 15px;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  height: 36px;
  padding-top: 14px;
  grid-row: 1 / 2;
  grid-column: 1 / -1;
`

export const Navigator = styled.div`
  position: absolute;
  top: 15px;
  right: 40px;
`

export const SidebarCloser = styled('div')<SideBarProps>`
  position: absolute;
  top: 0;
  right: 0;
  width: calc(100vw - 300px);
  height: 100%;
  right: ${({ isSidebarShowing }) => (isSidebarShowing ? '0%' : '100%')};
  transition: right 0.5s;
  z-index: 4;

  /* a real scrim on the web layout — the same one the modal host uses */
  ${media.web} {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    transition: opacity 0.35s ease-out;
    z-index: 5;
    background: rgba(111, 111, 111, 0.5);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    opacity: ${({ isSidebarShowing }) => (isSidebarShowing ? 1 : 0)};
    pointer-events: ${({ isSidebarShowing }) =>
      isSidebarShowing ? 'auto' : 'none'};
  }
`

export const CoverSidebarCloseHandler = styled('div')<SideBarProps>`
  position: absolute;
  top: 5vw;
  left: ${({ isSidebarShowing }) =>
    isSidebarShowing ? 'calc(100% - 38px - 5vw)' : '-150%'};
  transition: left 0.5s;
  transition-delay: 0.05s;

  /* the drawer sits on the right now, so the close button moves beside it */
  ${media.web} {
    position: fixed;
    top: 16px;
    left: auto;
    right: ${({ isSidebarShowing }) => (isSidebarShowing ? '396px' : '-150%')};
    transition: right 0.35s ease-out;
    z-index: 7;
  }
`
